import React from "react";
import logo from "../../../Assets/logo-pos1.png";

export const BizXPos = () => {
  return <img
    style={{ width: 20 }}
    src={logo}
    alt="logo"
  />
};